import { useParams } from "react-router-dom";

import "components/home_page/digital_info/digital_info.css";
import DataProvider from "hoc/data_provider";
import NewsBoardLoader from "components/loader/NewsBoardLoader";
import useMetadata from "hooks/useMetadata";

const DepartmentNewsEvents = () => {
    const { department } = useParams();
    const endPoint = `/web/department/news-events/${department}`;
    return (
        <DataProvider
            endPoint={endPoint}
            department={department}
            component={CombinedNewsEventBox}
            title="News & Events"
            icon="fas fa-newspaper"
            loader={NewsBoardLoader}
            style={{ maxWidth: "100%", minHeight: "400px", flex: "1" }}
        />
    );
};

export default DepartmentNewsEvents;

export const CombinedNewsEventBox = ({ title, icon, data, ...other }) => {
    // Hide events whose date has already passed; news/notices are always shown.
    data = data.filter((v) => {
        var today = new Date();
        return v.kind !== "event" || Date.parse(v.date) >= today;
    });

    return (
        <div className="info-box column news-box" {...other}>
            <div className="box-header row r-c-y">
                <div className="icon-title row r-c-y r-c-x">
                    <div className="header-icon">
                        <i className={icon}></i>
                    </div>
                    <h4 className="header-title">{title}</h4>
                </div>
            </div>

            <div className="info-box-content">
                {data.length > 0 ? (
                    Array.from(data, (v, i) => {
                        return <CombinedNewsEventRow key={i} data={data[i]} />;
                    })
                ) : (
                    <p className="no-data">News & event details will be updated here...</p>
                )}
            </div>
        </div>
    );
};

const CombinedNewsEventRow = ({ data }) => {
    const { proxy } = useMetadata();
    let endPoint = null;
    if (data.file) {
        endPoint = `${proxy}/download/files/${data.file}`;
    }
    return (
        <div className="info-box-data row r-c-y">
            <div className="data-icon"></div>
            <div className="data-wrapper">
                {data.file ? (
                    <a href={endPoint} className="data">
                        {data.title}
                    </a>
                ) : (
                    <p className="data">{data.title}</p>
                )}
                <p className="date-time">{data.date.substring(0, 10)}</p>
            </div>
        </div>
    );
};
